import React, {Component} from 'react';
import socketio from 'socket.io-client';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSpinner} from '@fortawesome/free-solid-svg-icons'
import './App.scss';
import Theme from "./components/Theme";
import Logo from "./components/Logo";
import LocationName from "./components/LocationName";
import {getCode, setCode} from './lib/code';
import CONSTANTS from "./constants/CONSTANTS";
import Slides from "./components/Slides";
import Status from "./components/Status";
import {persistData, retrieveData} from "./lib/persist";
import QRCode from "./components/QRCode";

class EnergyScreen extends Component {

    screenUpdateTimeout = null;
    reconnectTimeout = null;

    state = {
        screenCode: getCode(),
        location: undefined,
        activated: false,
        loading: true,
        theme: '',
        brand: '',
        io: null,
        slides: [],
        lastUpdate: Date.now(),
    };

    constructor(props){
        super(props);
        this.updateScreen.bind(this);
        this.connectSocket.bind(this);
    }

    componentDidMount = () => {
        this.connectSocket(true);

        if (!this.state.screenCode) {
            fetch(`${CONSTANTS.SERVER_URL}/energyscreens`, {
                method: 'POST'
            })
                .then(res => res.json())
                .then(body => {
                    setCode(body.energyscreens.Code);
                    this.setState({screenCode: body.energyscreens.Code, loading: false});
                })
        } else {
            this.loadScreenData();
            this.reconnectTimeout = setInterval(this.connectSocket, 10 * 60  * 1000);
        }

    };

    connectSocket = (initial = false) => {
        if(this.state.socket && this.state.socket.connected)
            return;
        try {
            const socket = socketio(CONSTANTS.SERVER_URL);

            socket.on('connect', () => {
                console.log('socket connected')
                if (this.state.screenCode)
                    socket.emit('screen-online', this.state.screenCode);
                if(!initial)
                    this.loadScreenData();
            });

            socket.on('disconnect', function () {
                console.log('socket disconnected')
                setTimeout(this.connectSocket, 60 * 1000);
            });

            socket.on('reload-data', this.updateScreen);

            this.setState({io: socket});
        }catch(e){
            console.log(e);
        }
    }

    updateScreen = () => {
        if (this.screenUpdateTimeout) {
            clearTimeout(this.screenUpdateTimeout);
        }
        this.screenUpdateTimeout = setTimeout(this.loadScreenData, 500);
    };

    loadScreenData = () => {
        fetch(`${CONSTANTS.SERVER_URL}/energyscreens/${this.state.screenCode}`, {
            method: 'GET'
        })
            .then(res => res.json())
            .then(body => {
                const newState = {
                    loading: false,
                    slides: body.energyscreens.Slides || [],
                    theme: body.energyscreens.Theme || 'sos',
                    brand: body.energyscreens.Brand || 'sos',
                    location: {},
                };

                if (body.energyscreens.Username) {
                    newState.activated = true;
                }

                if (body.location) {
                    newState.location = body.location;
                }

                if (newState.activated) {
                    newState.lastUpdate = Date.now();
                }

                this.setState(newState);
                persistData(newState);
            })
            .catch(() => {
                const newState = retrieveData();
                newState.loading = false;

                this.setState(newState);
            });
    };

    render() {
        const {loading, theme, brand, activated, slides, location, lastUpdate, screenCode} = this.state;

        if (loading) {
            return (
                <div style={{
                    fontSize: '5em',
                    color: '#4040CC',
                    height: '100vh',
                    display: 'flex', // make us of Flexbox
                    alignItems: 'center', // does vertically center the desired content
                    justifyContent: 'center', // horizontally centers single line items
                    textAlign: 'center', // optional, but helps horizontally center text that breaks into multiple lines
                }}>
                    <FontAwesomeIcon icon={faSpinner} spin/>
                </div>
            )
        }

        if (activated)
            return (
                <Theme theme={theme} brand={brand}>
                    <div className="grid-container">
                        <Logo brand={brand}/>
                        <LocationName theme={theme} location={location}/>
                        <Slides slides={slides} brand={brand} theme={theme} location={location}/>
                        <Status reload={this.loadScreenData} lastUpdate={lastUpdate}/>
                    </div>
                </Theme>
            );

        return (
            <QRCode screenCode={screenCode}/>
        )
    }
}

export default EnergyScreen;
